import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {dashboardGetSchoolsAuthor} from '../../../../Schools/actions';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../../translations/translations_schools';

class DashboardSchoolsSearch extends Component {
    state = {
        filter: '',
        userClick: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.setState({
            filter: this.props.filter,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {dashboardSchoolsLoading} = this.props.schools;

        if (this.state.filter !== prevState.filter && this.state.userClick && !dashboardSchoolsLoading) {
            this.props.changeFilter(this.state.filter);

            switch (this.state.filter) {
                case 'author':
                    // Fetch the schools where the current logged in user is the author
                    this.props.dashboardGetSchoolsAuthor(
                        1, // No offset
                        true, // Reset the search results / listing
                    );
                    break;
                default:
                    break;
            }
        }
    }

    handleChange = e => {
        // NB: setState is asynchronous!
        // If we call the dashboardGetSchoolsAuthor method here, it'll be triggered before the state changed.
        // We'll use componentDidUpdate() => called after the state has changed

        this.setState({
            [e.target.name]: e.target.value,
            'userClick' : true,
        });
    };

    render() {
        const {dashboardSchoolsLoading} = this.props.schools;

        return (
            <section id="schools-search">
                <form autoComplete="off">
                    <div className="row row-search">
                        <div className="col col-6">
                            <FormControl disabled={dashboardSchoolsLoading}>
                                <InputLabel htmlFor="schools-category">
                                    <Translate id="dashboard_schools.filter_by" />
                                </InputLabel>
                                <Select
                                    value={this.state.filter}
                                    onChange={this.handleChange}
                                    inputProps={{
                                        name: 'filter',
                                        id: 'schools-filter',
                                    }}
                                    autoWidth
                                >
                                    <MenuItem value="author">
                                        <Translate id="dashboard_schools.filter_schools_author" />
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </form>
            </section>
        );
    }
}

DashboardSchoolsSearch.propTypes = {
    dashboardGetSchoolsAuthor: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
    schools: state.schools,
});

export default connect(mapStateToProps, {dashboardGetSchoolsAuthor})(withLocalize(DashboardSchoolsSearch));



// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Schools/List/DashboardSchoolsSearch.js